// PastPerformanceService (zou, via sabaody) client. Built here rather than in
// lib/connect/clients.ts because @mono/proto-clients does not re-export it yet.
import { createClient } from '@connectrpc/connect';
import { PastPerformanceService } from '../../../../../gen/ts/mono/projectdata/v1/past_performance_connect';
import { connectTransport } from '../../lib/connect/transport';
export const pastPerformanceClient = createClient(PastPerformanceService, connectTransport);
